import React from 'react';

export default ({ loading, disabled, className, children, ...props }) => {
  return (
    <button
      disabled={disabled}
      className={`${className}`}
      {...props}
    >
      {loading && <div className="btn-spinner loader-text text-primary" />}
      {children}
    </button>
  );
};
